import React from "react";
import { Formik, Form, FieldArray } from "formik";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Grid,
  GridItem,
  Text,
  FormErrorMessage,
  Flex,
  Select,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { setEducationHistories } from "../redux/slices/individualRegistrationSlice";

const IndividualEducationHistory = ({ handlePrevious, handleNext }) => {
  const dispatch = useDispatch();
  const educationHistories = useSelector(
    (state) => state?.individualRegistration?.educationHistories || []
  );

  const initialValues = {
    educationHistories: educationHistories.length
      ? educationHistories
      : [
          {
            school: "",
            courseOfStudy: "",
            qualification: "",
            yearOfGraduation: "",
          },
        ],
  };

  const handleSubmit = async (values) => {
    dispatch(setEducationHistories(values.educationHistories));
    handleNext(values);
    console.log("Values: ", values);
  };

  return (
    <Box px={["30px", "40px", "40px", "50px"]}>
      <Text fontSize="20px" fontWeight="700">
        Education History
      </Text>
      <Text mt={3} mb={5} fontSize="16px" color="#7A7A7A">
        Please provide your academic background.
      </Text>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, handleChange, handleBlur, errors, touched }) => (
          <Form>
            <FieldArray name="educationHistories">
              {({ push, remove }) => (
                <>
                  {values.educationHistories.map((entry, index) => (
                    <Box
                      key={index}
                      border="1px solid #E2E8F0"
                      borderRadius="lg"
                      p={5}
                      mb={5}
                    >
                      <Grid templateColumns={["1fr", "1fr 1fr"]} gap={6}>
                        <GridItem colSpan={2}>
                          <FormControl
                            isInvalid={
                              touched.educationHistories?.[index]?.school &&
                              errors.educationHistories?.[index]?.school
                            }
                          >
                            <FormLabel>School</FormLabel>
                            <Input
                              name={`educationHistories[${index}].school`}
                              value={entry.school}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Enter school name"
                              bg="#F3F3F3"
                            />
                            <FormErrorMessage>
                              {errors.educationHistories?.[index]?.school}
                            </FormErrorMessage>
                          </FormControl>
                        </GridItem>

                        <GridItem>
                          <FormControl
                            isInvalid={
                              touched.educationHistories?.[index]
                                ?.courseOfStudy &&
                              errors.educationHistories?.[index]?.courseOfStudy
                            }
                          >
                            <FormLabel>Course of Study</FormLabel>
                            <Input
                              name={`educationHistories[${index}].courseOfStudy`}
                              value={entry.courseOfStudy}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Enter course"
                              bg="#F3F3F3"
                            />
                            <FormErrorMessage>
                              {
                                errors.educationHistories?.[index]
                                  ?.courseOfStudy
                              }
                            </FormErrorMessage>
                          </FormControl>
                        </GridItem>

                        <GridItem>
                          <FormControl
                            isInvalid={
                              touched.educationHistories?.[index]
                                ?.qualification &&
                              errors.educationHistories?.[index]?.qualification
                            }
                          >
                            <FormLabel>Qualification Obtained</FormLabel>
                            <Select
                              name={`educationHistories[${index}].qualification`}
                              value={entry.qualification}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Select qualification"
                              bg="#F3F3F3"
                            >
                              <option value="SSCE">SSCE</option>
                              <option value="OND">OND</option>
                              <option value="HND">HND</option>
                              <option value="B.Sc">B.Sc</option>
                              <option value="M.Sc">M.Sc</option>
                              <option value="PhD">PhD</option>
                              <option value="Others">Others</option>
                            </Select>
                            <FormErrorMessage>
                              {
                                errors.educationHistories?.[index]
                                  ?.qualification
                              }
                            </FormErrorMessage>
                          </FormControl>
                        </GridItem>

                        <GridItem>
                          <FormControl
                            isInvalid={
                              touched.educationHistories?.[index]
                                ?.yearOfGraduation &&
                              errors.educationHistories?.[index]
                                ?.yearOfGraduation
                            }
                          >
                            <FormLabel>Year of Graduation</FormLabel>
                            <Input
                              name={`educationHistories[${index}].yearOfGraduation`}
                              value={entry.yearOfGraduation}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              type="number"
                              placeholder="Enter year"
                              bg="#F3F3F3"
                            />
                            <FormErrorMessage>
                              {
                                errors.educationHistories?.[index]
                                  ?.yearOfGraduation
                              }
                            </FormErrorMessage>
                          </FormControl>
                        </GridItem>
                      </Grid>

                      <Button
                        mt={4}
                        colorScheme="red"
                        size="sm"
                        onClick={() => remove(index)}
                        isDisabled={values.educationHistories.length === 1}
                      >
                        Remove
                      </Button>
                    </Box>
                  ))}

                  <Button
                    onClick={() =>
                      push({
                        school: "",
                        courseOfStudy: "",
                        qualification: "",
                        yearOfGraduation: "",
                      })
                    }
                    colorScheme="green"
                    mb={6}
                  >
                    Add Another
                  </Button>
                </>
              )}
            </FieldArray>

            <Flex justify="space-between" mt={10}>
              <Button
                bg="#A6A6A6"
                color="#FFFFFF"
                w="200px"
                onClick={handlePrevious}
              >
                Back
              </Button>
              <Button bg="#23A455CC" color="#FFFFFF" w="200px" type="submit">
                Next
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default IndividualEducationHistory;
